import { useLookerModelId } from './use-looker-model-id';

export function useLookerDashboardId() {
  const modelId = useLookerModelId();

  return (id: string) => {
    if (/^\d+$/.test(id)) {
      // id is a number -> user-defined dashboard
      return id;
    } else {
      // id is a string -> lookml dashboard
      return `${modelId}::${id}`;
    }
  };
}
